// Age Gate
// Consent se ukládá do localStorage na 7 dní
// Smazání: odstranit tento soubor, age-gate.less, snippets/age-gate.liquid
//          a 3 řádky v theme.liquid

(function () {
  var KEY = 'age_gate_confirmed';
  var DAYS = 7;

  function isConfirmed() {
    var stored = localStorage.getItem(KEY);
    if (!stored) return false;
    var expires = parseInt(stored, 10);
    return Date.now() < expires;
  }

  function confirm() {
    var expires = Date.now() + DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(KEY, expires);
    var gate = document.getElementById('age-gate');
    if (gate) gate.classList.add('is-hidden');
    document.body.style.overflow = '';
  }

  function init() {
    var gate = document.getElementById('age-gate');
    if (!gate) return;

    if (isConfirmed()) {
      gate.classList.add('is-hidden');
      return;
    }

    document.body.style.overflow = 'hidden';

    var btn = document.getElementById('age-gate-confirm');
    if (btn) btn.addEventListener('click', confirm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
